import { useDispatch } from 'react-redux'
import { type QuickMdDispatch } from '@/app/store'

export const useAppDispatch = useDispatch.withTypes<QuickMdDispatch>()
